import {Component, ComponentRef, Injector, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {BaseAdminPanelComponent} from "./base-admin-panel.component";
import {Observable} from "rxjs";
import {IManagableObject} from "../IManagableObject";
import {ObjectGroupViewModel} from "../ObjectGroupViewModel";
import {GroupManagementDialogComponent} from "../group-management-dialog/group-management-dialog.component";
import {ObjectsManagementDialogComponent} from "../objects-management-dialog/objects-management-dialog.component";

declare const $;

@Component({
    selector: 'app-group-base-admin-panel',
    template: '',
    standalone: false
})
export class GroupBaseAdminPanelComponent extends BaseAdminPanelComponent implements OnInit {
  @ViewChild('groupFilter', /* TODO: add static flag */ {static: true})
  protected groupFilter;

  @ViewChild("groupMgmtDialog", /* TODO: add static flag */ { static: false, read: ViewContainerRef }) groupsContainer;

  groupMgmtDialog: ComponentRef<any>;

  @ViewChild("objectsListDialog", /* TODO: add static flag */ { static: false, read: ViewContainerRef }) objectsListContainer;

  objectsListDialog: ComponentRef<any>;

  protected doCreateGroup(input: IManagableObject): Observable<any> {
    return undefined;
  };

  protected doDeleteGroup(input: IManagableObject): Observable<any> {
    return undefined;
  };

  protected groupName;

  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.groupFilter.onAddGroup.subscribe(() => {
      this.addGroup();
    });
    this.groupFilter.onEditGroup.subscribe((group) => {
      this.editGroup(group);
    });
    this.groupFilter.onSelectGroup.subscribe((group) => {
      this.selectGroup(group);
    });
    this.groupFilter.onDeleteGroup.subscribe((group) => {
      this.doDeleteGroup(group)
        .subscribe(() => {
            if (this.groupName)
              this.syncService.NotifyEntityChanged(this.groupName,group.Name);
            let idx = this.groupFilter.groups.indexOf(group);
            if (idx < 0) return;
            this.groupFilter.groups.splice(idx, 1);
          });
    })
  }

  public addGroup() {
    this.groupMgmtDialog = this.dialogService.open(this.groupsContainer,GroupManagementDialogComponent);
    this.initGroupMgmtDialog();
    this.groupMgmtDialog.instance.open(new ObjectGroupViewModel());
  }

  private initGroupMgmtDialog() {
    let allObjects = this.objects.map(x => Object.assign({}, x));

    this.groupMgmtDialog.instance.onSubmit.subscribe(() => {
      let input = this.groupMgmtDialog.instance.object as ObjectGroupViewModel;
      input.objects = this.groupMgmtDialog.instance.objects.map(driver => driver.Id);
      this.doCreateGroup(input).subscribe(() => {
          if (this.groupName)
            this.syncService.NotifyEntityChanged(this.groupName, input.Name);
          this.Refresh();
        });
      this.groupMgmtDialog.instance.close();
    });
    this.groupMgmtDialog.instance.onOpen.subscribe(() => {
      let group = this.groupMgmtDialog.instance.object as ObjectGroupViewModel;
      this.groupMgmtDialog.instance.objects = allObjects.filter(d => group.objects.indexOf(d.Id) >= 0)
        .map(obj => {
          obj.IsChecked = false;
          return obj;
        });
    });

    this.groupMgmtDialog.instance.onClose.subscribe(() => {
    });

    this.groupMgmtDialog.instance.onAddObjects.subscribe(() => {
      this.objectsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);
      this.objectsListDialog.instance.onOpen.subscribe(() => {

        this.objectsListDialog.instance.groups = this.groupFilter.groups;
        //не входят в текущую группу
        this.objectsListDialog.instance.objects = allObjects.filter(d => this.groupMgmtDialog.instance.objects.find(dr => dr.Id == d.Id) == undefined)
          .map(x => Object.assign({}, x))
          .map(obj => {
            obj.IsChecked = false;
            return obj;
          });
      });

      this.objectsListDialog.instance.onSubmit.subscribe(() => {
        this.objectsListDialog.instance.objects.forEach(driver => {
          if (driver && driver.IsChecked) {
            if (this.groupMgmtDialog.instance.objects.indexOf(driver) < 0) {
              driver.IsChecked = false;
              this.groupMgmtDialog.instance.objects.push(driver);
            }
          }
        });
        this.objectsListDialog.instance.close();
      });
      this.objectsListDialog.instance.onClose.subscribe(() => {
      });
      this.objectsListDialog.instance.open();
    });
  }

  public editGroup(group: ObjectGroupViewModel) {
    this.groupMgmtDialog = this.dialogService.open(this.groupsContainer,GroupManagementDialogComponent);
    this.initGroupMgmtDialog();
    this.groupMgmtDialog.instance.open(group);
  }

  public selectGroup(group: ObjectGroupViewModel) {
    this.filter.group = group;
    setTimeout(function () { $(".dropclick").removeClass("opened"); }, 100);
  }
}
